export type TabsOrientation = 'horizontal' | 'vertical'

export type TabItem = {
  id: string
  label: string
}

export type TabsPreviewCount = 2 | 3 | 4

export const TABS_PREVIEW_COUNTS: TabsPreviewCount[] = [2, 3, 4]

export const TABS_PREVIEW_COUNT_LABELS: Record<TabsPreviewCount, string> = {
  2: '2 tabs',
  3: '3 tabs',
  4: '4 tabs',
}

export const TABS_DEMO_ITEMS: TabItem[] = [
  { id: 'tab-1', label: 'Tab 1' },
  { id: 'tab-2', label: 'Tab 2' },
  { id: 'tab-3', label: 'Tab 3' },
  { id: 'tab-4', label: 'Tab 4' },
]

export const TABS_LIVE_ITEMS: TabItem[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'details', label: 'Details' },
  { id: 'history', label: 'History' },
  { id: 'notes', label: 'Notes' },
]

export type TabsProps = {
  items?: TabItem[]
  value?: string
  defaultValue?: string
  orientation?: TabsOrientation
  disabled?: boolean
  className?: string
  /** Dark surface styling (aligned with other DS dark controls). */
  darkMode?: boolean
  /** Static active tab index for the design-system showcase only. */
  previewActiveIndex?: number
  /** Static visual state for single-tab showcase rows. */
  previewTabState?: 'selected' | 'default'
  onChange?: (tabId: string) => void
}
